export default __webpack_public_path__ + "static/media/agradecimiento.3ff6d248.png";